import { render, staticRenderFns } from "./productTkl.vue?vue&type=template&id=22769809&scoped=true&"
import script from "./productTkl.vue?vue&type=script&lang=js&"
export * from "./productTkl.vue?vue&type=script&lang=js&"
import style0 from "./productTkl.vue?vue&type=style&index=0&id=22769809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22769809",
  null
  
)

export default component.exports